export default __webpack_public_path__ + "static/media/client3.2aee3365.png";